// extracted by mini-css-extract-plugin
export var dialog = "MessageDialog-module--dialog--D7l+w";
export var goBackButton = "MessageDialog-module--goBackButton--UDezb";
export var proceedButton = "MessageDialog-module--proceedButton--pu2fH";